/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { productClientControllerFindByIdV1 } from '../fn/product-client/product-client-controller-find-by-id-v-1';
import { ProductClientControllerFindByIdV1$Params } from '../fn/product-client/product-client-controller-find-by-id-v-1';
import { productClientControllerSearchV1 } from '../fn/product-client/product-client-controller-search-v-1';
import { ProductClientControllerSearchV1$Params } from '../fn/product-client/product-client-controller-search-v-1';
import { ProductDto } from '../models/product-dto';

@Injectable({ providedIn: 'root' })
export class ProductClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productClientControllerSearchV1()` */
  static readonly ProductClientControllerSearchV1Path = '/api/v1/products/client';

  /**
   * Search products (client).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productClientControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  productClientControllerSearchV1$Response(params: ProductClientControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = productClientControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search products (client).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productClientControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productClientControllerSearchV1(params: ProductClientControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.productClientControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<ProductDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `productClientControllerFindByIdV1()` */
  static readonly ProductClientControllerFindByIdV1Path = '/api/v1/products/client/{id}';

  /**
   * Find product detail (client).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  productClientControllerFindByIdV1$Response(params: ProductClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    const obs = productClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Find product detail (client).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productClientControllerFindByIdV1(params: ProductClientControllerFindByIdV1$Params, context?: HttpContext): Observable<ProductDto> {
    const resp = this.productClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

}
